import React from 'react'
import clsx from 'clsx'
import NextImage from 'next/image'
import NextLink from 'next/link'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import { Header } from 'app/KinerjaShared/components/Header'
import { SimpleCard } from 'app/KinerjaPSPegawaiPage/components/SimpleCard'
import CircularProgressV2 from 'app/KinerjaPSPage/components/CircularProgressV2'
import {
  PERENCANAAN_TIM_KINERJA_MENUS,
  PERENCANAAN_PEJABAT_PENILAI_KINERJA_MENUS,
} from 'app/KinerjaTimPenilaiPSPage/constants/perencanaan'
import { useSummary } from 'app/KinerjaTimPenilaiPSPage/hooks/useSummary'
import useBasePath from 'app/KinerjaTimPenilaiPSPage/hooks/useBasePath'

const OptionCards = ({ isTimKinerjaPengawasSekolah }) => {
  const { basePath } = useBasePath()

  return (
    <>
      {(isTimKinerjaPengawasSekolah
        ? PERENCANAAN_TIM_KINERJA_MENUS
        : PERENCANAAN_PEJABAT_PENILAI_KINERJA_MENUS
      ).map((spec, index) => (
        <SimpleCard
          key={`card-${index}`}
          className={clsx('space-y-6 p-6 flex-1', spec?.bgColor ?? '')}
        >
          <div className="space-y-1">
            <Text variant="heading-lg" color={spec.textColor}>
              {spec.title}
            </Text>
            <Text variant="body-lg" color={spec.textColor}>
              {spec.subtitle}
            </Text>
          </div>

          <div>
            <NextLink href={`${basePath}/${spec.path}`} passHref>
              <Button as="a" color={spec.ctaColor} className="w-56">
                {spec.ctaText}
              </Button>
            </NextLink>
          </div>
        </SimpleCard>
      ))}
    </>
  )
}

type TimPenilaiPSPerencanaanPageProps = {}
const TimPenilaiPSPerencanaanPage: React.FC<
  TimPenilaiPSPerencanaanPageProps
> = ({}) => {
  const {
    basePath,
    isTimKinerjaPengawasSekolahUrl: isTimKinerjaPengawasSekolah,
  } = useBasePath()

  // Summary API
  const { apiStatus, summary } = useSummary()

  if (apiStatus === 'loading') {
    return null
  }

  return (
    <div className="pb-20">
      <Header
        title="Rangkuman Perencanaan Kinerja"
        className="mb-9 print:hidden"
      />

      <div className="pt-4">
        <div className="flex items-center justify-between p-6 space-x-8 bg-white border-b rounded-t-lg border-subdued">
          <div className="w-[106px] h-[106px] flex-none">
            <CircularProgressV2
              value={summary?.perencanaan?.done ?? 0}
              maxValue={summary?.perencanaan?.total ?? 0}
              textVariant="heading-sm"
            />
          </div>
          <div className="col-span-10 space-y-3 grow">
            <div className="space-y-1">
              <div>
                <Text variant="display-sm" color="informational">
                  {summary?.perencanaan?.done ?? 0} dari{' '}
                  {summary?.perencanaan?.total ?? 0}
                </Text>
              </div>
              <div>
                <Text variant="heading-lg" color="subdued">
                  Perencanaan sudah disetujui Pejabat Penilai Kinerja
                </Text>
              </div>
            </div>

            <div className="w-48">
              <NextLink
                href={`${basePath}/penilai/perencanaan/daftar-ps/disetujui`}
                passHref
              >
                <Button as="a" disabled={!Boolean(summary?.perencanaan?.done)}>
                  Cek Perencanaan
                </Button>
              </NextLink>
            </div>
          </div>

          <div className="flex-none">
            <NextImage
              src="/illustrations/img-document-penci-fill.png"
              width="100px"
              height="110px"
            />
          </div>
        </div>

        <div className="flex justify-between px-6 space-x-8 py-9 bg-surface-selected-default">
          <OptionCards
            isTimKinerjaPengawasSekolah={isTimKinerjaPengawasSekolah}
          />
        </div>
      </div>
    </div>
  )
}
export default TimPenilaiPSPerencanaanPage
